import API from 'shared/lib/api'

export default {

  // Delete resource from the API.
  //
  // @example
  //   SomeModel.actions.delete(id: 1, optimistic: true)
  //
  actionMethod: (model, options = {}) => {
    options.apiVersion = options.apiVersion ?? model.options.apiVersion

    return API.deleteResource(model.pluralName, options.id, options)
  },

  // Updates record (optimistically) in the collection.
  //
  reduceMethod: (model, collection, action) => {
    const options = action?.payload?.options || {}
    const id = options.id

    switch (action?.type) {
      case model.actionTypes.DELETE_START:
        if (id) {
          // Set delete flags
          collection = collection.update(id, { isBusy: true, pendingDelete: true })

          // Optimistic delete record from collection
          if (options.optimistic) {
            collection = collection.delete(id)
          }
        }

        return collection

      case model.actionTypes.UPDATE_ERROR:
        if (id) {
          // Set error flag
          collection = collection.update(id, {
            isBusy: false,
            pendingDelete: true,
            hasError: true,
            errorData: action?.payload?.error
          })

          if (options.optimistic) {
            // TODO: Optimistic delete failed
            console.log('Record was deleted optimistically but the action failed, what to do now?')
          }
        }

        return collection

      case model.actionTypes.DELETE_SUCCESS:
        // Because of pusher, it is possible to have two DELETE_SUCCESS events, but only one DELETE_START
        // To ensure idempotency we must double check that is present in the collection, before attempting
        // to update its `pendingDelete` state
        if (id && collection.getById(id)) {
          // Remove delete flags
          collection = collection.update(id, { isBusy: false, pendingDelete: false })
        }

        // Delete record
        return collection.delete(id)
    }
  }
}
